import { render, staticRenderFns } from "./interior.vue?vue&type=template&id=2954b17c&scoped=true"
import script from "./interior.vue?vue&type=script&lang=js"
export * from "./interior.vue?vue&type=script&lang=js"
import style0 from "./interior.vue?vue&type=style&index=0&id=2954b17c&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2954b17c",
  null
  
)

export default component.exports